import React, { useState, useEffect } from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import useMediaQuery from "@mui/material/useMediaQuery";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import Menu from "@mui/material/Menu";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import Authorization from "../../utils/authorization";
import AssociateLayout from "../Associates/Layout/Layout";
import UserLayout from "../Users/Layout/Layout";
import { deletingProfile, getMembership, getProfileData } from "../../api/api";
import SubordinateLayout from "../SubOrdinates/Layout/Layout";
import { ls } from "../../utils/localStorage";
import { toast, Zoom } from "react-toastify";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Slide,
} from "@mui/material";
import Drawer from "@mui/material/Drawer";
import Logo from "../../assets/2.svg";

const drawerWidth = 250;
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(({
  theme,
  open,
}) => {
  {
    let obj = {};
    if (open) {
      obj = {
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create("margin", {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: `${drawerWidth}px`,
        // marginLeft: 60,
        [theme.breakpoints.down("sm")]: {
          marginLeft: 0,
        },
        [theme.breakpoints.down("xs")]: {
          marginLeft: 0,
        },
      };
    } else {
      obj = {
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create("margin", {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 60,
        [theme.breakpoints.down("sm")]: {
          marginLeft: 0,
        },
        [theme.breakpoints.down("xs")]: {
          marginLeft: 0,
        },
      };
    }
    return obj;
  }
});

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const WebDrawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const Layout = () => {
  const theme = useTheme();
  const isMobileDrawer = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [membership, setMembership] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [isPendingProfile, setIsPendingProfile] = useState(false);
  const [isDeleteProfile, setIsDeleteProfile] = useState(false);
  const role = "";
  const location = useLocation();
  const isAssociatelogin =
    Authorization.getUserType() === "Associate" ? true : false;
  const isSubordinateLogin =
    Authorization.getUserType() === "Employee" ? true : false;
  // location && location.pathname && location.pathname.includes("sub-ordinate");
  console.log(isSubordinateLogin);

  useEffect(() => {
    checkSubscription();
    const user = ls.getItem("profile_for_reference");
    const parsedUser = user ? JSON.parse(user) : null;
    setUserDetails(parsedUser);

    // Load latest profile to hydrate avatar image/details if available.
    (async () => {
      try {
        const response = await getProfileData();
        if (response && response.status >= 200 && response.status <= 300) {
          setUserDetails((prev) => ({
            ...(prev || {}),
            ...(response?.data || {}),
          }));
        }
      } catch (error) {
        // Ignore avatar hydration failures and keep existing local user data.
      }
    })();
  }, []);

  useEffect(() => {
    checkProfileCompletion();
    const interval = setInterval(() => checkProfileCompletion(), 60000);
    return () => {
      clearInterval(interval);
    };
  }, []);
  console.log(userDetails);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const logout = () => {
    Authorization.logout();
    ls.clear();
  };

  const deleteProfile = async () => {
    try {
      const response = await deletingProfile();
      if (response.status === 204) {
        Authorization.logout();
        ls.clear();
      }
    } catch (error) {
      toast.error(
        error?.message
          ? error.message
          : error?.response?.data?.error?.message || "Something went wrong",
        {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
          transition: Zoom,
        },
      );
    }
  };

  const checkProfileCompletion = async () => {
    if (userDetails) {
      const response = await getProfileData();
      console.log("profile data", response);
      if (response && response.status >= 200 && response.status <= 300) {
        const profileData = response;

        if (
          profileData?.marital_status == "" ||
          profileData?.body_type == "" ||
          profileData?.dob == "" ||
          profileData?.time_of_birth == "" ||
          profileData?.is_mobileno == false ||
          profileData?.age == "" ||
          profileData?.physical_status === "" ||
          profileData?.height === null ||
          profileData?.weight === null ||
          profileData?.religion === "" ||
          profileData?.caste === "" ||
          profileData?.sub_caste === "" ||
          profileData?.zodiac === "" ||
          profileData?.star === "" ||
          profileData?.country === "" ||
          profileData?.city === null ||
          profileData?.state === undefined ||
          profileData?.education === 0 ||
          profileData?.occupation === "" ||
          profileData?.employeed_in == "" ||
          profileData?.salary == "" ||
          profileData?.mobileno === "" ||
          profileData?.image === "" ||
          profileData?.no_of_sisters_married == 0 ||
          profileData?.no_of_sisters === 0 ||
          profileData?.no_of_brothers_married === 0 ||
          profileData?.no_of_brothers === 0 ||
          profileData?.mothers_occupation === "" ||
          profileData?.mothers_occupation === "" ||
          profileData?.fathers_occupation === "" ||
          profileData?.family_status === "" ||
          profileData?.family_type === "" ||
          profileData?.mother_tongue === ""
        ) {
          // setIsPendingProfile(true);
        } else {
          setIsPendingProfile(false);
        }
      }
    }
  };

  const checkSubscription = async () => {
    try {
      const response = await getMembership();
      if (response && response.status >= 200 && response.status <= 300) {
        setMembership(response?.data?.is_membership);
      }
    } catch (error) {
      setMembership(false);
      toast.error(
        error?.response?.data?.error?.message || "Something wend wrong",
        {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
          transition: Zoom,
        },
      );
    }
  };

  const profilePage = () => {
    navigate("/auth/profile");
  };

  const historyPage = () => {
    navigate("/auth/history");
  };

  const assosiateProfilePage = () => {
    navigate("associates/view-profile");
  };

  const subOrdinateProfilePage = () => {
    navigate("employee/view-profile");
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const DrawerList = (
    <Box
      sx={{ width: drawerWidth }}
      role="presentation"
      onClick={() => handleDrawerClose(false)}
    >
      <IconButton
        onClick={() => handleDrawerClose}
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
        }}
      >
        {theme.direction === "rtl" ? <ChevronRightIcon /> : <ChevronLeftIcon />}
      </IconButton>
      <Divider />
      {isAssociatelogin ? (
        <AssociateLayout open={open} />
      ) : isSubordinateLogin ? (
        <SubordinateLayout open={open} />
      ) : (
        <UserLayout open={open} membership={membership} />
      )}
    </Box>
  );

  return (
    <Box>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: "#fff",
        }}
        open={open}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              marginRight: 0,
              ...(open && { display: "none" }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <div>
            <img src={Logo} alt="Logo" style={{ width: "100%", height: 60 }} />
          </div>
          <Typography sx={{ flexGrow: 1 }} variant="h6" noWrap component="div">
            {isAssociatelogin
              ? "Associate"
              : isSubordinateLogin
                ? "Employee"
                : ""}
          </Typography>
          <Box>
            <IconButton
              size="large"
              aria-label="show more"
              color="inherit"
              onClick={handleClick}
            >
              <Avatar
                src={
                  userDetails?.image ||
                  userDetails?.profile_image ||
                  userDetails?.images?.[0] ||
                  undefined
                }
                sx={{
                  width: 30,
                  height: 30,
                  // bgcolor: "#f44336",
                  border: "1px solid #fff",
                }}
              />
            </IconButton>
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
              disableScrollLock
            >
              <MenuItem
                onClick={
                  isAssociatelogin
                    ? assosiateProfilePage
                    : isSubordinateLogin
                      ? subOrdinateProfilePage
                      : profilePage
                }
              >
                Profile
              </MenuItem>
              <MenuItem onClick={historyPage}>Payment history</MenuItem>
              <MenuItem onClick={() => setIsDeleteProfile(true)}>
                Delete Profile
              </MenuItem>
              <MenuItem onClick={logout}>Logout</MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer
        sx={{ zIndex: 1500, display: { xs: "block", sm: "block", md: "none" } }}
        open={isMobileDrawer && open}
        onClose={() => handleDrawerClose(false)}
      >
        {DrawerList}
      </Drawer>
      <WebDrawer
        variant="permanent"
        sx={{
          display: {
            xs: "none",
            sm: "none",
            md: "block",
          },
        }}
        open={open}
      >
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />

        {isAssociatelogin ? (
          <AssociateLayout open={open} />
        ) : isSubordinateLogin ? (
          <SubordinateLayout open={open} />
        ) : (
          <UserLayout open={open} membership={membership} />
        )}
      </WebDrawer>
      <Main open={open}>
        <DrawerHeader />
        <Outlet />
      </Main>
      <Dialog
        open={isPendingProfile}
        slots={{
          transition: Transition,
        }}
        keepMounted
        onClose={() => setIsPendingProfile(false)}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            HI {userDetails?.name}, You are not filling your profile details.
            Please complete your profile to get more matches.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              border: "1px solid",
            }}
            onClick={() => setIsPendingProfile(false)}
          >
            Later
          </Button>
          <Button
            autoFocus
            sx={{
              border: "1px solid",
              bgcolor: "#ff8000",
              color: "#fff",
              // "&:hover": {
              //   bgcolor: "#ff8000",
              // },
            }}
            onClick={() => {
              navigate("/auth/edit-profile");
              setIsPendingProfile(false);
            }}
          >
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={isDeleteProfile}
        slots={{
          transition: Transition,
        }}
        keepMounted
        onClose={() => setIsDeleteProfile(false)}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Are you sure you want to delete your profile? This action cannot be
            undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              border: "1px solid",
            }}
            onClick={() => setIsDeleteProfile(false)}
          >
            Cancel
          </Button>
          <Button
            autoFocus
            sx={{
              border: "1px solid",
              bgcolor: "#ff8000",
              color: "#fff",
              // "&:hover": {
              //   bgcolor: "#ff8000",
              // },
            }}
            onClick={() => {
              deleteProfile();
              setIsDeleteProfile(false);
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Layout;
